<template>
    <ion-modal :is-open="isOpenRef" @onDidDismiss="setOpen(false)">
        <shipment-line-boxes-detail
            :shipment="shipment"
            :line="line"
            :shipping-data="boxes"
            @updated="$emit('updated')"
            @close="close()"
        />
    </ion-modal>
</template>

<script>
import {IonModal} from '@ionic/vue';
import { ref } from 'vue';
import ShipmentLineBoxesDetail from "@/views/modules/checking/pages/check/components/ShipmentLineBoxesDetail";
import EventBus from "@/EventBus";
export default {
    name: "ShipmentLineBoxesModal",
    props: ['shipment'],
    inject: ['$http'],
    emits: ['updated'],
    components: {
        ShipmentLineBoxesDetail,
        IonModal
    },
    methods: {
        close() {
            this.setOpen(false);
        },
        open(line, split) {
            EventBus().emitter.emit('loading', true);
            this.$http.get(`/api/checks/lines/${line.id}/boxes`, {
                params: {
                    include: 'location,sku,item,boxes,boxes.items',
                    split: split
                }
            }).then(response => {
                // not sure why we had to do it like this,
                // passing it in via props didn't seem to work
                this.boxes = response.data;
                this.line = line;
                this.setOpen(true);
            }).finally( () => {
                EventBus().emitter.emit('loading', false);
            }) ;
        }
    },
    data() {
        return {
            line: {},
            boxes: []
        }
    },
    setup() {
        const isOpenRef = ref(false);
        const setOpen = (state) => isOpenRef.value = state;
        return { isOpenRef, setOpen }
    }
}
</script>
